import {HttpClient, HttpIntercepting} from '@ubud/http';
import {InjectionToken} from '@angular/core';
import {HttpInterceptor} from '@angular/common/http';
import {LEMSAR_API_INTERCEPTORS} from '@lemsar/api/interceptor';

export class LemsarApiClient extends HttpClient implements HttpIntercepting {
    public getInterceptorToken(): InjectionToken<HttpInterceptor[]> {
        return LEMSAR_API_INTERCEPTORS;
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/api/client.ts